//Library
import React, { Component } from 'react';
//redux
import { connect } from 'react-redux';

class Step0 extends Component {

    render() {
        return <article>
            <section id="announcement" className="bgblack">
                <div className="sectionblock">
                    <div className="featureBox announcementblock">
                        <div className="titleblock"><img src="./assets/imgs/notice.png" alt=""/></div>
                        {
                            this.props.TSRDataInfo !== undefined ? 
                            <p>您持有的<span className="bluetext">《（{this.props.TSRDataInfo.outFundID}）{this.props.TSRDataInfo.outFundName}》</span>即將於<span className="bluetext"> {this.props.TSRDataInfo.clearDate} </span>因合併或清算/徹銷核備等因素，並終止在台銷售，<span className="bluetext">{this.props.TSRDataInfo.dueDate} 14:00</span>為最後贖回日。</p> : ""
                        }

                        <p>因合併或清算/徹銷核備後的存續基金並未在台銷售，在作業完成生效日後，針對合併或清算/徹銷核備後的基金只能接受書面執行賣出交易。為避免影響到您日後的投資權益，建議您在最後贖回日前執行轉換交易。若您同意執行轉換基金交易請按同意後登入。</p>

                        <p>若您有其他相關問題，歡迎您致電 02-27208126 按 9，由專人為您服務。</p>
                    </div>
                </div>
                <div className="btnblock btnagree" onClick={this.props.nextStep}>同意</div>
            </section>
        </article>
    }
}
function mapStateToProps(state) {
    return {
        TSRDataInfo: state.anueInfoState.TSRDataInfo,
    };
}
export default connect(mapStateToProps)(Step0);